import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ContactChangeFields from "./ContactChangeFields";

// "עדכון איש קשר" dialog - the customer enters the correct contact person
const ContactChangeDialog = (props) => {
  const { contactDialogOpen, contactFieldErrors, contactEmailFormatInvalid } = props;
  const { handleContactDialogCancel, handleContactDialogSave } = props;
  const contactEmailErrorMessage =
    contactFieldErrors.contactEmail ||
    (contactEmailFormatInvalid ? "שדה אימייל יכול להכיל כתובת מייל תקינה בלבד" : "");

  return (
    <Dialog
      open={contactDialogOpen}
      onClose={handleContactDialogCancel}
      dir="rtl"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>עדכון איש קשר</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          מי איש הקשר הנכון?
        </DialogContentText>
        <ContactChangeFields {...props} contactEmailErrorMessage={contactEmailErrorMessage} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleContactDialogCancel} color="primary">
          ביטול
        </Button>
        <Button
          onClick={handleContactDialogSave}
          color="primary"
          variant="contained"
          disabled={
            (!!contactFieldErrors.contactName && contactFieldErrors.contactName !== "שדה חובה") ||
            (!!contactFieldErrors.contactPhone && contactFieldErrors.contactPhone !== "שדה חובה") ||
            contactEmailFormatInvalid
          }
        >
          שמירה
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactChangeDialog;
